// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"create-memory-step-one_style_mainContainer__5iZ28"};